<template>
    <ul :class="layoutClass">
        <li>
            <el-checkbox v-model="item.checked" @change="$emit('singleElection')"></el-checkbox>
        </li>
        <li class="main">
            <goods-info :item="item" tag="秒杀"></goods-info>
            <div class="cutom-cart-info">
                <goods-message :goods="item"></goods-message>
            </div>
        </li>
        <li class="mini-li" v-if="layoutClass === 'mini'">
            <cartAndOrder_price :info="item"></cartAndOrder_price>
            <el-button type="text" @click="$emit('deleteCart')">删除</el-button>
        </li>
        <li>
            <cartAndOrder_price :info="item"></cartAndOrder_price>
        </li>
        <li>
            <el-input-number v-model="item.num" :step="item.min_buy || 1" size="mini" :min="item.min_buy || 1" :max="item.stock" @change="cartNumChange"></el-input-number>
        </li>
        <li><strong class="subtotal ns-text-color">￥{{ calculationOfPrice(item) }}</strong></li>
        <li>
            <el-button type="text" @click="$emit('deleteCart')">删除</el-button>
        </li>
    </ul>
</template>
<script>
    import CartItemMixin from "@/views/goods/cart/common/cart-item-mixin"
    import GoodsMessage from "@/components/goods-message/goods-message.vue"
    import cartAndOrder_price from "@/components/cartAndOrder/cartAndOrder_price.vue"
    export default {
        name: 'default-cart-item',
        mixins: [CartItemMixin],
        components: {
            GoodsMessage,
            cartAndOrder_price
        },
        computed: {
            calculationOfPrice() {
                return (item) => {
                    let {num,goods_min,goods_limit,price,discount_price} = item;
                    let totalPrice = 0;
                    if(num>=goods_min){
                        if(goods_limit > 0 && num > goods_limit){
                            let price1 = ((parseInt(num)-parseInt(goods_limit))*parseFloat(price)); 
                            let price2 = (parseInt(goods_limit)*parseFloat(discount_price));
                            this.item.subtotal = (price1+price2).toFixed(2);
                        }else{
                            this.item.subtotal = (parseInt(num)*parseFloat(discount_price)).toFixed(2);
                        }
                    }else{
                        this.item.subtotal = (parseInt(num)*parseFloat(price)).toFixed(2)
                    }
                    return this.item.subtotal
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '../common/list.scss';
.cutom-cart-info{
    display: flex;
    flex-direction: column;
    padding-left: 70px;
    box-sizing: border-box;
}
</style>
